// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"content_contentContainer__ur1H4","noCrumbs":"content_noCrumbs__Iy4w_","breadCrumbs":"content_breadCrumbs__FTcRM"};